var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTickets = function SvgTickets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hy-tickets",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "hy-top-card"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.913978 15.5813L15.5813 0.913978C16.0861 0.409208 16.9044 0.409208 17.4092 0.913978L25.3285 8.83323C25.8332 9.338 25.8332 10.1564 25.3285 10.6612L10.6612 25.3285C10.1564 25.8332 9.338 25.8332 8.83323 25.3285L0.913978 17.4092C0.409208 16.9044 0.409208 16.0861 0.913978 15.5813Z",
    fill: "#00FF96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5344 16.48L10.3055 18.1775L10.9222 14.5821L8.30994 12.0358L11.9199 11.5112L13.5344 8.23999L15.1488 11.5112L18.7588 12.0358L16.1466 14.5821L16.7633 18.1775L13.5344 16.48Z",
    fill: "#00AA64"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.24265 20.8571L25.223 10.4775C25.8413 10.1208 26.6317 10.3326 26.9887 10.9507L32.5941 20.6581C32.9512 21.2762 32.7394 22.0668 32.1212 22.4237C32.1212 22.4237 32.1211 22.4238 32.121 22.4237L14.1407 32.8033C13.5224 33.16 12.732 32.9482 12.3749 32.3302L6.76958 22.6227C6.41249 22.0046 6.62426 21.214 7.24246 20.8571C7.2425 20.8571 7.24254 20.857 7.24265 20.8571Z",
    fill: "#00AA64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8899 24.7267L16.6924 26.4077L17.3031 22.8472L14.7162 20.3256L18.2912 19.8061L19.8899 16.5667L21.4887 19.8061L25.0637 20.3256L22.4768 22.8472L23.0875 26.4077L19.8899 24.7267Z",
    fill: "white"
  }))));
};
export default SvgTickets;